import React from 'react';

import {
    useCurationConfigValue
} from '../../../hooks/widgetConfiguration.js';

import useCDNUrl from '../../../hooks/useCDNUrl.js';

import RIQButton from '../../../components/RIQButton.jsx';

import {
    listeningDefinitions
} from './enums/listeningDefinitions.jsx';


export default function SavedTopicsUpsellWidget({instanceId}) {

    const plan = useCurationConfigValue('plan');
    const isTrial = (plan.kind === 'trial');
    const numSavedSearchesAllowed = plan?.max_listening_saved_searches;
    const showUpsell = (!plan?.has_full_instant_search || !numSavedSearchesAllowed);
    const emptyListeningUrl = useCDNUrl('/images/listening-empty2.svg');

    if (!showUpsell) {
        return null;
    }

    function onClick() {
        RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ClickedListeningUpsell, {
            source: 'saved-search-list'
        });

        window.location.href = '/manage#subscription';
    }

    const {
        title,
        titleTrial,
        description
    } = listeningDefinitions[instanceId] || {};

    return (
        <div className='tlw-mb-10 tlw-flex tlw-flex-col tlw-rounded tlw-bg-white tlw-shadow-panel '>
            <div className='tlw-grid tlw-grid-cols-1 tlw-p-8 md_tlw-grid-cols-2'>
                <img
                    className='tlw-m-auto tlw-max-h-[180px]'
                    alt='error'
                    src={emptyListeningUrl}
                />
                <div className='tlw-my-10 tlw-grid tlw-justify-center'>
                    <h2 className='tlw-mb-2 tlw-ml-4 tlw-text-lg'>
                        {(isTrial ? titleTrial : title)}
                    </h2>
                    {description}
                    <div>
                        <RIQButton
                            className='tlw-mx-4 tlw-px-6 tlw-py-3'
                            variant='primary'
                            onClick={onClick}
                        >
                            Compare Plans
                        </RIQButton>
                    </div>
                </div>
            </div>
        </div>
    );
}
